export default {"src":"/_next/static/media/error500.863579b0.svg","height":340,"width":597,"blurWidth":0,"blurHeight":0};